import Constants from "const/constants";

import UserModel from "../model/user";
import BaseCollection from "./base";

var UsersCollection = BaseCollection.extend({
    // Override Properties / Methods

    model: UserModel,

    url: function () {
        return `${Constants.DEFAULT_API_PATH}/users`;
    },

    parse: function (response) {
        return response.data;
    },

    comparator: `email`,

    search: function (query) {
        return UsersCollection.__super__.search.call(
            this,
            [`name`, `email`],
            query
        );
    },

    getActiveWithoutRole: function (roleName) {
        return this.filter(function (user) {
            return user.isActive() && !user.hasRole(roleName);
        });
    },

    getNonSuspendedUsersWithoutRole: function (roleName) {
        return this.filter(function (user) {
            return (
                !user.isSuspended() &&
                !user.isDeleted() &&
                !user.hasRole(roleName)
            );
        });
    },

    getActiveUsers: function () {
        return this.filter(function (user) {
            return user.isActive();
        });
    },

    filterByRole: function (roleName) {
        return this.filter(function (user) {
            return user.hasRole(roleName);
        });
    },

    filterByNotRole: function (roleName) {
        return this.filter(function (user) {
            return !user.hasRole(roleName);
        });
    },

    getConnectedUsers: function () {
        return this.filter((user) => user.get(`connected`));
    }
});

export default UsersCollection;
